/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

import { formatErrorResponse } from 'responseFormatterFunctions';
import { I18NError } from 'Utils';
import { fetchGet } from 'FetchAPIs';

const baseAvailabilityURL = '/api/availability';

const messages = defineMessages({
  errorLoadingManageAvailability: 'Error loading manage availability. {message}',
});

/**
 * Function that gets manage availability
 * @returns current manage status
 */
export const getManageAvailability = async (): Promise<any> =>
  fetchGet(`${baseAvailabilityURL}/manage`, null, null)
    .then(response => response)
    .catch(error => {
      throw new I18NError(messages.errorLoadingManageAvailability, {
        message: formatErrorResponse(error),
      });
    });
